/**
 * Upozornění pro účetní na nové převody mezi kolegy.
 * Počítá se čistě na klientu z dat „Ke kontrole" (shared-with-me) — stejný
 * princip jako odznak obnovy u Karet zaměstnanců (žádný cron/e-mail na backendu).
 *
 * Odznak = počet odchozích převodů, které už příjemce přijal (jsou tedy hotové),
 * ale účetní je u odesílatele ještě nezkontrolovala (overeno = false).
 */
import { useSharedVyuctovani } from '../../api/hooks';

export function useVyuctovaniUpozorneniCount(): number {
  const { data: groups = [] } = useSharedVyuctovani();
  let n = 0;
  for (const g of groups) {
    for (const p of g.prevody_odchozi ?? []) {
      if (p.prijato && !p.overeno) n += 1;
    }
  }
  return n;
}
